import React from "react";
import { Input } from "@cadmakers-ui/core";
import styles from "./CheckItem.module.scss";

type CheckItemProps = {
  checked?: boolean;
  indeterminate?: boolean;
  label: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  key?: number;
};

export const CheckItem: React.FC<CheckItemProps> = ({
  checked,
  indeterminate,
  label,
  onChange,
  key
}) => {
  return (
    <div className={styles["check-item"]}>
      <Input
        key={key}
        type="checkbox"
        checked={checked || indeterminate || false}
        customOption={{ small: true, indeterminate }}
        onChange={onChange}
        translate
      />
      <span>{label}</span>
    </div>
  );
};
